import { render, staticRenderFns } from "./DangerItem.vue?vue&type=template&id=336ad9be&scoped=true&"
import script from "./DangerItem.vue?vue&type=script&lang=js&"
export * from "./DangerItem.vue?vue&type=script&lang=js&"
import style0 from "./DangerItem.vue?vue&type=style&index=0&id=336ad9be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336ad9be",
  null
  
)

export default component.exports